import React from 'react';
import {
  Invoice,
  InvoiceStatusEnum,
  InvoiceStatusNames,
} from '@zonofi/zono-money-store';
import './invoice-list.scss';
import { getInvoiceIcon, getInvoiceStatusStyle } from './helper';
import moment from 'moment';
import { getFormattedAmount } from '@zonofi/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WEBROUTES } from '@zonofi/zono-money-helpers';

export const InvoiceList: React.FC<{
  invoiceList: Invoice[];
}> = ({ invoiceList }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams?.get('token');
  const sellerWorkspaceId = searchParams?.get('sellerWorkspaceId');
  const inviteId = searchParams?.get('inviteId');

  return invoiceList?.map((invoice, idx) => {
    const icon = getInvoiceIcon(invoice.invoiceStatus as InvoiceStatusEnum);
    const statusStyle = getInvoiceStatusStyle(
      invoice.invoiceStatus as InvoiceStatusEnum
    );
    return (
      <div
        key={idx}
        className="invoice-list-item"
        onClick={() => {
          navigate(
            `${WEBROUTES.INVOICE}/${invoice.id}?token=${token}&sellerWorkspaceId=${sellerWorkspaceId}&inviteId=${inviteId}&docNumber=${invoice.docNumber}&showBack=true`
          );
        }}
      >
        <div className="invoice-list-item-top">
          {/* <img src={icon} alt="" /> */}
          <div className="invoice-list-item-top-details">
            <div className="invoice-list-item-top-details-doc-number font-primary-semibold">
              {invoice.docNumber}
            </div>
            <div className="invoice-list-item-top-details-customer font-primary">
              {moment(invoice.invoiceDate).format('MMM DD, YY')} •{' '}
              {invoice.customerName}
            </div>
          </div>
          <div
            className={`invoice-list-item-top-badge font-primary-semibold ${statusStyle.backgroundClass} ${statusStyle.textClass}`}
          >
            {
              InvoiceStatusNames[
                invoice.invoiceStatus as keyof typeof InvoiceStatusNames
              ]
            }
          </div>
        </div>
        <div className="invoice-list-item-bottom">
          <div className="invoice-list-item-bottom-details">
            <div className="invoice-list-item-bottom-details-label font-primary">
              Amount
            </div>
            <div className="invoice-list-item-bottom-details-value font-primary-semibold">
              {getFormattedAmount(invoice.invoiceAmount, true)}
            </div>
          </div>
          <div className="invoice-list-item-bottom-details">
            <div className="invoice-list-item-bottom-details-label font-primary">
              Due Date
            </div>
            <div className="invoice-list-item-bottom-details-value font-primary-semibold">
              {moment(invoice.dueDate).format('MMM DD, YY')}
            </div>
          </div>
          <div className="invoice-list-item-bottom-details">
            <div className="invoice-list-item-bottom-details-label font-primary">
              Outstanding
            </div>
            <div className="invoice-list-item-bottom-details-value font-primary-semibold">
              {getFormattedAmount(
                invoice.invoiceAmount - invoice.paidAmount,
                true
              )}
            </div>
          </div>
        </div>
      </div>
    );
  });
};
